export function s2ab(s: string) {
  var buf = new ArrayBuffer(s.length)
  var view = new Uint8Array(buf)
  for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
  return buf
}

export const fileContentToBlob = (data: string, type: string): Blob => {
  var blob = new Blob([s2ab(window.atob(data))], {
    type: type,
  })
  return blob
}

export const exportJsonToFile = (data: any, filename: string) => {
  try {
    const jsonString = JSON.stringify(data, null, 2)
    const blob = new Blob([jsonString], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `${filename}.json`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
    return true
  } catch (error) {
    console.error('Error exporting JSON:', error)
    return false
  }
}
